// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__16dbT","logo":"Footer_logo__3V8sT","socialMedia":"Footer_socialMedia__2s_4V","contact":"Footer_contact__3fRyN","prydeLink":"Footer_prydeLink__2zqqq"};